import { Component, inject, input, output } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { GeneralSelectors } from '@hunting-nature/Secacam/shared/redux/general/general.reducer';
import { IonButtons, IonIcon } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';

import { AppButtonComponent } from '@hunting-nature/shared-ui/components/app-button/app-button.component';
import type { BottomSheetSettings } from '@hunting-nature/shared-ui/components/bottom-sheet/bottom-sheet.component';
import { BottomSheetComponent } from '@hunting-nature/shared-ui/components/bottom-sheet/bottom-sheet.component';
import { pickIcons } from '@hunting-nature/shared-ui/helper/icon-registry.const';
import { Store } from '@ngrx/store';
import { addIcons } from 'ionicons';

@Component({
  selector: 'app-offline-mode-sheet',
  imports: [TranslocoPipe, AppButtonComponent, IonButtons, BottomSheetComponent, IonIcon],
  templateUrl: './offline-mode-sheet.component.html',
  styleUrl: './offline-mode-sheet.component.scss',
})
export class OfflineModeSheetComponent {
  // services
  private readonly store = inject(Store);

  // inputs
  public readonly open = input.required<boolean>();

  // outputs
  public readonly updateStatus = output<void>();
  public readonly goToSystemSettings = output<void>();
  public readonly closed = output<void>();
  public readonly dismissed = output<void>();

  // UI bindings
  protected readonly useDarkMode$$ = this.store.selectSignal(GeneralSelectors.isUseDarkMode);
  protected readonly isNativePlatform = Capacitor.isNativePlatform();

  protected offlineModeSheetSettings: BottomSheetSettings = {
    fitHeight: true,
  };

  constructor() {
    addIcons(pickIcons('reload', 'open-in-new'));
  }

  // handlers
  protected handleSheetClosed(): void {
    this.closed.emit();
  }

  protected handleSheetDismissed(): void {
    this.dismissed.emit();
  }

  protected handleUpdateStatus(): void {
    this.updateStatus.emit();
  }

  protected handleGoToSystemSettings(): void {
    this.goToSystemSettings.emit();
  }
}
